import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import { Theme } from "../../data/style/Theme";
import TextField from "@mui/material/TextField";
import useScreenSize from "../../context/ScreenContext";
import { SecondaryTitle } from "../../data/style/Style";
import InputAdornment from "@mui/material/InputAdornment";

const SelectInput = (props) => {
  let {
    options,
    label,
    setValue,
    value,
    hasNull,
    hasAll,
    def,
    data,
    disabled,
    icon,
    placeholder,
  } = props;

  let handleValueChange = (e) => setValue(parseInt(e.target.value));

  const { size } = useScreenSize();
  var [width] = size;
  return (
    <Stack gap={1} width={"100%"}>
      <SecondaryTitle sx={{ fontSize: "0.6rem !important" }}>
        {label}
      </SecondaryTitle>
      <TextField
        fullWidth
        select
        size="small"
        variant="standard"
        value={value}
        disabled={disabled}
        defaultValue={def}
        placeholder={placeholder}
        onChange={handleValueChange}
        sx={{
          border: 1,
          borderRadius: 3,
          p: 1,
          background: Theme.palette.card,
          borderColor: Theme.palette.borderLight,
          width: "95%",
          fontSize: "10px",
        }}
        SelectProps={{
          MenuProps: {
            style: {
              maxHeight: 400,
            },
          },
          sx: {
            fontSize: width < 750 ? "0.7rem" : "0.8rem",
            color: Theme.palette.text,
            fontFamily: "DM Sans",
          },
        }}
        InputProps={{
          disableUnderline: true,
          startAdornment: icon ? (
            <InputAdornment position="start">
              <span style={{ fontSize: "1.1rem" }}>{icon}</span>
            </InputAdornment>
          ) : undefined,
        }}
      >
        {hasNull && (
          <MenuItem key={-1} value={``}>
            &nbsp;
          </MenuItem>
        )}
        {hasAll && (
          <MenuItem key={-1} value={-1}>
            All
          </MenuItem>
        )}
        {options.map((item, index) => (
          <MenuItem
            sx={{
              color: "#201F1F",
              fontSize: width < 750 ? "0.8rem" : "1rem",
              fontFamily: "DM Sans",
              "&:focus": {
                background: Theme.palette.muted,
                color: Theme.palette.orange,
              },
              "&:hover": {
                background: Theme.palette.muted,
                color: Theme.palette.orange,
              },
            }}
            key={index}
            value={
              data === "exercise"
                ? item.exercise
                : data === "structure"
                  ? item.structure
                  : item.id
            }
          >
            {data === "exercise" ? item.exercise_name : item.name}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
};
export default SelectInput;
